import {Injectable} from '@angular/core';
import {Disposable} from '../utilities/Disposable';
import {AssistanceApplicationFileType} from '../shared/enums/assistance-application-file-type';

@Injectable({
    providedIn: 'root',
})
export class FileUploadService extends Disposable {

    constructor() {
        super();
    }

    public photoIdTypes = [
        AssistanceApplicationFileType.PhotoId
    ];

    public ssnProofTypes = [
        AssistanceApplicationFileType.SsnProof,
        AssistanceApplicationFileType.TaxReturns,
        AssistanceApplicationFileType.SsiSsdiAwardLetter
    ];

    public proofOfIncomeTypes = [
        AssistanceApplicationFileType.CheckStub,
        AssistanceApplicationFileType.TaxReturns,
        AssistanceApplicationFileType.ProfitLossStatement
    ];

    public employmentTypes = [
        AssistanceApplicationFileType.UtilityBill,
        AssistanceApplicationFileType.TaxStatement,
        AssistanceApplicationFileType.TaxReturns,
        AssistanceApplicationFileType.BankStatement,
        AssistanceApplicationFileType.GovtOrCourtRecord,
        AssistanceApplicationFileType.GovtBenefitsStatement,
        AssistanceApplicationFileType.SsiSsdiAwardLetter,
        AssistanceApplicationFileType.UnemploymentAward,
        AssistanceApplicationFileType.WicSnapAwardLetter,
        AssistanceApplicationFileType.EmployerLetter
    ];

    public incomeTypes = [
        AssistanceApplicationFileType.CheckStub,
        AssistanceApplicationFileType.PensionLetter,
        AssistanceApplicationFileType.GovtBenefitsStatement,
        AssistanceApplicationFileType.SsiSsdiAwardLetter,
        AssistanceApplicationFileType.UnemploymentAward,
        AssistanceApplicationFileType.WicSnapAwardLetter,
    ];

    public stlWaterIncomeTypes = [
        AssistanceApplicationFileType.ArmedForcesAllotment,
        AssistanceApplicationFileType.TANF,
        AssistanceApplicationFileType.ChildSupport,
        AssistanceApplicationFileType.UnionFunds,
        AssistanceApplicationFileType.PensionLetter,
    ];

    public selfEmployedTypes = [
        AssistanceApplicationFileType.TaxReturns,
        AssistanceApplicationFileType.ProfitLossStatement
    ];

    public utilityBillTypes = [
        AssistanceApplicationFileType.UtilityBill,
        AssistanceApplicationFileType.UtilityShutoffNotice,
        AssistanceApplicationFileType.DelinquentWaterBill
    ];

    public childcareTypes = [
        AssistanceApplicationFileType.ChildcareBill
    ];

    public childEnrollmentTypes = [
        AssistanceApplicationFileType.ChildEnrollmentProof
    ];

    public childEducationProgressTypes = [
        AssistanceApplicationFileType.ChildEducationProgressReport
    ];

    public evictionTypes = [
        AssistanceApplicationFileType.EvictionCourtOrder,
        AssistanceApplicationFileType.EvictionNotice
    ];

    public leaseAgreementTypes = [
        AssistanceApplicationFileType.LeaseAgreement
    ];

    public landlordOwnershipTypes = [
        AssistanceApplicationFileType.LandlordProofOfOwnership
    ];

    public rentLandlordFormTypes = [
        AssistanceApplicationFileType.RentLandlordForm
    ];

    public delinquentRentNoticeTypes = [
        AssistanceApplicationFileType.DelinquentRentNotice
    ];

    public transportationTypes = [];

    public carRepairTypes = [
        AssistanceApplicationFileType.AutoRepairBill
    ];

    public carOwnershipTypes = [
        AssistanceApplicationFileType.AutoTitle
    ];

    public proofOfResidenceTypes = [
        AssistanceApplicationFileType.ProofOfResidence,
        AssistanceApplicationFileType.PhotoId,
        AssistanceApplicationFileType.UtilityBill,
        AssistanceApplicationFileType.TaxReturns,
        AssistanceApplicationFileType.VoterRegistration,
    ];

    public stlWaterDelinquentWaterBill = [
        AssistanceApplicationFileType.DelinquentWaterBill
    ];

    public mortgageTypes = [AssistanceApplicationFileType.MortgageStatement];
    public movingExpenseTypes = [AssistanceApplicationFileType.MovingExpenseBill];
    public carPaymentTypes = [AssistanceApplicationFileType.AutoPaymentStatement];
    public carInsuranceTypes = [AssistanceApplicationFileType.AutoInsuranceBill];
    public tuitionTypes = [AssistanceApplicationFileType.TuitionBill];
    public schoolSuppliesTypes = [AssistanceApplicationFileType.ChildEducationBill];
    public tutoringTypes = [AssistanceApplicationFileType.ChildTutoringBill];

    // -----------------------------
// STORM / TORNADO RESPONSE
// -----------------------------

    public appliancesTypes = [
        AssistanceApplicationFileType.ApplianceInvoice
    ];

    public constructionTypes = [
        AssistanceApplicationFileType.ConstructionBidInvoice
    ];

    public hvacPlumbingTypes = [
        AssistanceApplicationFileType.HvacPlumbingBidInvoice
    ];

    public moldRemediationTypes = [
        AssistanceApplicationFileType.MoldRemediationInvoice,
    ];

    public otherUnmetNeedsTypes = [
        AssistanceApplicationFileType.OtherDisasterNeeds,
    ];

    public storageTypes = [
        AssistanceApplicationFileType.StorageStatement,
    ];


    public getFileRequirementStatus(currentFiles: AssistanceApplicationFileType[]): FileUploadChecklist {
        return {
            photoId: currentFiles.includes(AssistanceApplicationFileType.PhotoId),
            employment: this.employmentTypes.some(x => currentFiles.includes(x)),
            income: this.incomeTypes.some(x => currentFiles.includes(x)),
            selfEmployed: this.selfEmployedTypes.some(x => currentFiles.includes(x)),
            utilityBill: this.utilityBillTypes.some(x => currentFiles.includes(x)),
            childcare: this.childcareTypes.some(x => currentFiles.includes(x)),
            transportation: this.transportationTypes.some(x => currentFiles.includes(x)),
            carRepair: this.carRepairTypes.some(x => currentFiles.includes(x)),
            evictionNotification: this.evictionTypes.some(x => currentFiles.includes(x))
        } as FileUploadChecklist;
    }
}

export interface FileUploadChecklist {
    photoId?: boolean;
    employment?: boolean;
    income?: boolean;
    selfEmployed?: boolean;
    utilityBill?: boolean;
    childcare?: boolean;
    transportation?: boolean;
    evictionNotification?: boolean;
}
